export default {
  sbTitle: "SB_TITLE",
  serviceBookSidebar: {
    used: "SERVICEBOOK_SIDEBAR_USED",
    free: "SERVICEBOOK_SIDEBAR_FREE",
    expired:"SERVICEBOOK_SIDEBAR_EXPIRED",
    buy_service_books:'BUY_SERVICE_BOOKS'
  },
  serviceBookModal: {
    selectApartment:"SERVICEBOOK_MODAL_SELECT_APARTMENT",
    createNewApartment:"SERVICEBOOK_MODAL_CREATE_NEW_APARTMENT",
    apartmentName:"SERVICEBOOK_MODAL_APARTMENT_NAME",
    selectAddress:"SERVICEBOOK_MODAL_SELECT_ADDRESS",
    createNewAddress:"SERVICEBOOK_MODAL_CREATE_NEW_ADDRESS",
    apartmentType:"SERVICEBOOK_MODAL_APARTMENT_TYPE",
    addressReference:"SERVICEBOOK_MODAL_ADDRESS_REF",
    location:"SERVICEBOOK_MODAL_BLOCK_LOCATION",
    associateServiceBook:"SERVICEBOOK_MODAL_ASSOCIATE_TITLE"
  }
}



// WEBPACK FOOTER //
// ./src/locales/service-book/index.ts